import classNames from 'clsx';
import React, { memo } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { EColor, FavoriteIcon } from 'reactApp/ui/FavoriteIcon/FavoriteIcon';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { sendGa } from 'reactApp/utils/ga';
import { noop } from 'reactApp/utils/helpers';

import styles from '../DataListItemRow.css';

const handleDoubleClick = (e) => {
    e.stopPropagation();
};

export const Favorite = memo(function Favorite({
    isAvailable,
    isActive,
    onClick,
    isActiveHidden,
}: {
    isAvailable: boolean;
    isActive: boolean;
    onClick: () => void;
    isActiveHidden?: boolean;
}) {
    const handleOnClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();

        sendGa('datalist-control', 'click', 'favorite', EViewMode.list);

        (isAvailable ? onClick : noop)();
    };

    return (
        <div
            className={classNames({
                [styles.favorite]: true,
                [styles.favorite_active]: isActive && !isActiveHidden,
            })}
            onClick={handleOnClick}
            onDoubleClick={handleDoubleClick}
        >
            {isAvailable && (
                <Hint text={isActive ? 'Убрать из избранных' : 'Добавить в избранные'}>
                    <div>
                        <FavoriteIcon active={isActive} color={EColor.RED} />
                    </div>
                </Hint>
            )}
        </div>
    );
});
